var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Container } from '../';
import { getBPHelpers } from '../../utils/breakpoints';
export var ModalActions = forwardRef(function ModalActions(_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, rest = __rest(_a, ["children", "className", "style"]);
    var themeContext = useContext(ThemeContext);
    var BPHelpers = getBPHelpers(themeContext.breakpoints);
    var screens = BPHelpers.useScreens();
    var padding = screens({
        small: 'small',
        medium: 'large'
    }, 'xlarge');
    return (React.createElement(Container, __assign({ top: padding, className: className, style: style, ref: ref }, rest), children));
});
ModalActions.displayName = 'ModalActions';
export default ModalActions;
//# sourceMappingURL=ModalActions.js.map